import {Document, Policy, Sms} from "@falcon/services";
import {notificationTemplates} from "./NotificationTemplates";

const SUPPRESSED_CANCELLATION_REASON_CODES = [
    "POLICY_HOLDER_DECEASED",
    "SUPPRESS_DOCUMENTS",
    "DECEASED",
    "FRAUD_RETAIN_PREMIUM_AND_SUPPRESS_DOCUMENTS",
];

const INSURER_CANCELLATION_SMS_TEMPLATE = "wolf_insurer_cancellation_sms";

export function shouldSuppressCancellationCommunications(policy?: Policy): boolean {
    const cancellationReasonCode = policy?.interaction?.cancellationReasonInfo?.cancellationReasonCode;

    return typeof cancellationReasonCode === "string" && SUPPRESSED_CANCELLATION_REASON_CODES.includes(cancellationReasonCode);
}

function isCancellationEmailDocument(document: Document): boolean {
    const matchingTemplate = notificationTemplates.emails.find(email =>
        email.template === document.name
    );

    return matchingTemplate?.description
        .toLowerCase()
        .includes("cancellation") ?? false;
}

function isCancellationSmsForInteraction(message: Sms, policy: Policy): boolean {
    return message.templateName === INSURER_CANCELLATION_SMS_TEMPLATE && message.interactionId === policy.interaction?._id;
}

export function filterSuppressedCancellationDocuments(
    documents: Document[],
    policy: Policy | undefined,
    cancellationDocumentNames: string[] = []
): Document[] {
    if (!shouldSuppressCancellationCommunications(policy)) {
        return documents;
    }

    return documents.filter((document: Document) =>
            !isCancellationEmailDocument(document)
            && !cancellationDocumentNames.some(
                documentName => document.name.includes(documentName)
            )
    );
}

export function filterSuppressedCancellationEmails(documents: Document[], policy?: Policy): Document[] {
    return filterSuppressedCancellationDocuments(documents, policy);
}

export function filterSuppressedCancellationSms(sms: Sms[], policy?: Policy): Sms[] {
    if (!policy || !shouldSuppressCancellationCommunications(policy)) {
        return sms;
    }

    return sms.filter((message: Sms) =>
        !isCancellationSmsForInteraction(message, policy)
    );
}
